module.exports = __webpack_public_path__ + "static/leseprobe1_kommentar-normvertrag_kap13-95b23e5aa433b507dc976d8370e4d2e5.pdf";